!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});



const newWorkBtn = document.querySelector("#worksheets-btn");
newWorkBtn.addEventListener("click", (e) => {
  checkID();
  showPatID();
  DisplayIdRegions();
  console.log(e);
});

const sonoLine = document.getElementById('sono')



function showPatID() {
  document.getElementById("patientId").style.display = "block";
}



const togMenuBtn = document.querySelector("#togMenu");

togMenuBtn.addEventListener("click", (e) => {
  myFunction();
  console.log(e);
});
function myFunction() {
  var x = document.getElementById("navDemo");
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else {
    x.className = x.className.replace(" w3-show", "");
  }
}
function printReport() {
  document.getElementById("nonPrintable").className += "noPrint";
  window.print();
}
const printReportBtn = document.querySelector("#printReport");
printReportBtn.addEventListener("click", (e) => {
  printReport();
  console.log(e);
});

function showReportModal() {
  document.getElementById("reportModal").style.display = "block";
}

window.onclick = function (event) {
  if (
    event.target.id == "id01" ||
    event.target.id == "id02" ||
    event.target.id == "id03" ||
    event.target.id == "id04" ||
    event.target.id == "id05" ||
    event.target.id == "reportModal" ||
    event.target.id == "patientId" ||
    event.target.id == "dhrInput"
  ) {
    document.getElementById(event.target.id).style.display = "none";
  }
};

function checkID() {
 if (identifier.patient === '' || identifier.sono === '') {
  showPatID();
 }
}
function addTitle() {
    if (history.side !== "" )  {
         document.getElementById('hisTitleRpt').innerHTML = `${history.side}`;
      } else  {
         checkSide();
      }
    }
    
function checkSide() {
 document.getElementById('clinSection').click();
};  

function hideRequired() {
    let required = document.querySelectorAll('.required')
    required.forEach( function (element) {
      element.style.display = 'none';

    })
  };
const history = {
    patID : "",
    side :"",
    onset : "",
    symptoms: "",
    trauma : "",
    roi : "",
    reportLine :function () {
      history.reportLine = clinReport();
    }
  };
  
  
  const identifier =  {
    patient: "",
    sono : "",
    reported : false,
  }
  
  function getPatID() {
    
  document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
    document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
    document.getElementById("patientId").style.display = "none";
  }
  
  const pDSubBtn = document.querySelector("#patDetSub");
  pDSubBtn.addEventListener("click", (e) => {
    
    identifier.patient = document.getElementById('patDet').value;
    identifier.sono = document.getElementById('sono').value;
    getPatID();
    populate();
    console.log(e);
  });

  
  
  
  
  const sideBtn = document.querySelectorAll(".hisSide");
  sideBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      hideRequired();
      history.side = e.target.textContent;
      if (identifier.reported === true) {
        populate();
    }
      console.log(e);
    });
  });
 
  const hisOnsBtn = document.querySelectorAll(".hisOns");
  hisOnsBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.onset = e.target.id;
      console.log(e);
    });
  });
  
  
  const hisSymBtn = document.querySelectorAll(".hisSym");
  hisSymBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.symptoms = e.target.textContent;
      console.log(e);
    });
  });
  
  
  const hisTraBtn = document.querySelectorAll(".hisTra");
  hisTraBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.trauma = e.target.id;
      console.log(e);
    });
  });
  
  const hisRoiBtn = document.querySelectorAll(".hisRoi");
  hisRoiBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.roi = e.target.textContent;
      console.log(e);
    });
  });
  
  function clinReport() {
      history.reportLine =
        history.onset + ' ' + history.roi + ' ' +
        history.symptoms + '. '+ history.trauma +'.'
  }

  function addClin() {
   clinReport();
   document.getElementById("hisRpt").innerHTML = boldString("Clinical Details - ","Clinical Details") + `${history.reportLine}`;
   addTitle();
    }
   
  
function showLHDiv() {
    var x = document.getElementById('latHip');
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
}
function showPHDiv() {
  var x = document.getElementById('postHip');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showAHDiv() {
  var x = document.getElementById('antHip');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showCDDiv() {
  var x = document.getElementById('clinDet');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showIRDiv() {
  var x = document.getElementById('inguinal');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}

const glutMed = {
    name : 'gluteus medius tendon',
    finding: 'Normal. ',
    tear: "",
    tearDim :'',
    tearRoi:"",
    ent: '',
    calcDim:'',
    tend:'',
    impression: '',
   reportLine : function () {
      glutMed.reportLine = glutMedReport();
    },
};
const glutMedLocDiv = document.querySelector('#glutMedLoc')
const glutMedTearDimReq = document.querySelector('#glutMedTearDimReq')
const glutMedTearBtn = document.querySelectorAll(".gmTear");
glutMedTearBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMed.tear = e.target.textContent;
    glutMedLocDiv.style.display = 'block'
    glutMedTearReq.style.display = 'inline'
    glutMedTearDimReq.style.display = 'inline'
    console.log(e);
  });
});
const glutMedTearRoiBtn = document.querySelectorAll(".gmRoi");
glutMedTearRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMed.finding = 'abnormal';
    glutMed.tearRoi = e.target.textContent;
    glutMedTearReq.style.display = 'none'
    console.log(e);
  });
});
const glutMedCalcDimReq = document.querySelector('#glutMedCalcDimReq');

function showGMedCalcDiv() {
    if (glutMed.ent === 'acute calcification' || glutMed.ent === 'chronic calcification') {
        glutMedCalcDimReq.style.display = 'inline';
    }
}

const glutMedEntBtn = document.querySelectorAll(".gmEnt");
glutMedEntBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMed.finding = 'abnormal';
    glutMed.ent = e.target.textContent;
    showGMedCalcDiv();
    console.log(e);
  });
});

const glutMedTendBtn = document.querySelectorAll(".gmTend"); 
glutMedTendBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMed.tend = e.target.textContent;
    console.log(e);
  });
});
const glutMedImpBtn = document.querySelectorAll(".gmImp");
glutMedImpBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMed.impression = e.target.textContent;
    console.log(e);
  });
});


const glutMedCalcDim = document.querySelector('#glutMedCalcDim')
glutMedCalcDim.addEventListener("focusout", (e) => {
    glutMed.calcDim = e.target.value;
    glutMedCalcDimReq.style.display = 'none' 
 });
const glutMedTearDim = document.querySelector('#glutMedTearDim')
glutMedTearDim.addEventListener("focusout", (e) => {
    glutMed.tearDim = e.target.value;
    glutMedTearDimReq.style.display = 'none'
 });

  


function glutMedReport() {
  if (glutMed.finding === 'Normal. ') {
    glutMed.reportLine = glutMed.finding;
  } else {
      glutMed.reportLine = glutMed.calcDim + ' ' + glutMed.ent + '.   ';
  } if (glutMed.tend !== '') {
        glutMed.reportLine += glutMed.tend + '   ';
    } if (glutMed.impression !== '') {
        glutMed.reportLine += ' consistent with '+ glutMed.impression + '.   '
    }
  if (glutMed.tear !== '') {
        glutMed.reportLine += glutMed.tearDim + ' ' + glutMed.tear + ' involving the ' +glutMed.tearRoi +'. '

    } 
}

const glutMin = {
    name: 'gluteus minimus tendon',
    finding: 'Normal. ',
    tear: "",
    tearDim :'',
    tearRoi:"",
    ent: '',
    calcDim:'',

    tend: '',
    impression: '',
    

   reportLine : function () {
      glutMin.reportLine = glutMinReport();
    },
};
const glutMinLocDiv = document.querySelector('#glutMinLoc')
const glutMinTearDimReq = document.querySelector('#glutMinTearDimReq')
const glutMinCalcDimReq = document.querySelector('#glutMinCalcDimReq')
const glutMinTearBtn = document.querySelectorAll(".gMinTear");
glutMinTearBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMin.tear = e.target.textContent;
    glutMinLocDiv.style.display = 'block'
    glutMinTearReq.style.display = 'inline'
    glutMinTearDimReq.style.display = 'inline'
    console.log(e);
  });
});
const glutMinTearRoiBtn = document.querySelectorAll(".gMinRoi");
glutMinTearRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMin.finding = 'abnormal';
    glutMin.tearRoi = e.target.textContent;
    glutMinTearReq.style.display = 'none'
    console.log(e);
  });
});
const glutMinCalcDim = document.querySelector('#glutMinCalcDim')
glutMinCalcDim.addEventListener("focusout", (e) => {
    glutMin.calcDim = e.target.value 
    glutMinCalcDimReq.style.display = 'none'
 });
const glutMinTearDim = document.querySelector('#glutMinTearDim')
glutMinTearDim.addEventListener("focusout", (e) => {
    glutMin.tearDim = e.target.value
    glutMinTearDimReq.style.display = 'none' 
 });
const glutMinImpBtn = document.querySelectorAll(".gMinImp");
glutMinImpBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMin.impression = e.target.textContent;
    console.log(e);
  });
});  
const glutMinTendBtn = document.querySelectorAll(".gMinTend");
glutMinTendBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMin.finding = 'abnormal';
    glutMin.tend = e.target.textContent;
    console.log(e);
  });
});

const glutMinEntBtn = document.querySelectorAll(".gMinEnt");
glutMinEntBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMin.finding = '';
    glutMin.ent = e.target.textContent;
    showGMinCalcDiv();
    console.log(e);
  });
});
function showGMinCalcDiv() {
    if (glutMin.ent === 'acute calcification' || glutMin.ent === 'chronic calcification') {
        glutMinCalcDimReq.style.display = 'inline'
    }
}
function glutMinReport() {
    if (glutMin.finding === 'Normal. ') {
      glutMin.reportLine = glutMin.finding;
    } else {
        glutMin.reportLine = glutMin.calcDim + ' ' + glutMin.ent + '.   ';
    } if (glutMin.tend !== '') {
          glutMin.reportLine += glutMin.tend + '   ';
      } if (glutMin.impression !== '') {
          glutMin.reportLine += ' consistent with '+ glutMin.impression + '.   '
      }
    if (glutMin.tear !== '') {
          glutMin.reportLine += glutMin.tearDim + ' ' + glutMin.tear + ' involving the ' +glutMin.tearRoi +'. '
  
      } 
  }
    
const bursa = {
    name: 'trochanteric bursa',
    thick:"Normal thickness. ",
    effusion : '',
    tender:'',
    roi:'',
    reportLine: function() {
        bursa.reportLine = glutBursaRpt();
    }
}
const burThickBtn = document.querySelectorAll(".burThi");
burThickBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.thick = e.target.id;
    console.log(e);
  });
});
const burEffBtn = document.querySelectorAll(".burEff");
burEffBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.effusion = e.target.id;
    console.log(e);
  });
});
const burTendBtn = document.querySelectorAll(".burTend");
burTendBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.tender = e.target.id;
    console.log(e);
  });
});
const burRoiBtn = document.querySelectorAll(".burRoi");
burRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    bursa.roi = e.target.id;
    console.log(e);
  });
});
function glutBursaRpt() {
    bursa.reportLine = bursa.thick  + bursa.effusion + bursa.tender
    if (bursa.roi === 'corresponds') {
        bursa.reportLine += '  Bursa corresponds to the patients ROI. '
    }
   }

const glutMusc = {
    name : 'gluteal muscles',
    atrophy : 'Normal. ',
    atrRoi : '',
    reportLine : function() {
      glutMusc.reportLine = glutMuscReport();
    },
}
function glutMuscReport() {
  if (glutMusc.atrophy === 'Normal. ' && glutApon.tend === 'normal') {
    glutMusc.reportLine = glutMusc.atrophy + '. Gluteal aponeurosis ' + glutApon.tend + '.';
  }
  else if  (glutMusc.atrophy !== 'Normal. ' && glutApon.tend === 'normal') {
    glutMusc.reportLine = glutMusc.atrophy + ' at the ' + glutMusc.atrRoi + '. Gluteal aponeurosis ' + glutApon.tend + '.';
  }
  else if (glutMusc.atrophy !== 'Normal. ' && glutApon.tend !== 'normal') {
    glutMusc.reportLine = glutMusc.atrophy + ' at the ' + glutMusc.atrRoi + '. Gluteal aponeurosis demonstrates ' + glutApon.tend + ' at its origin, which ' + glutApon.roi + ' to the patients ROI.';
  }
 else {
  glutMusc.reportLine = glutMusc.atrophy + '. Gluteal aponeurosis demonstrates ' + glutApon.tend + ' at its origin, which ' + glutApon.roi + ' to the patients ROI.';
}};


const glutAtrBtn = document.querySelectorAll(".gluAtr");
glutAtrBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMusc.atrophy = e.target.textContent;
    console.log(e);
  });
});
const glutAtRoiBtn = document.querySelectorAll(".gluAtrRoi");
glutAtRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutMusc.atrRoi = e.target.textContent;
    console.log(e);
  });
}); 
const glutApon = {
    name: 'gluteal aponeurosis',
    tend : 'normal',
    roi : '',
    
} 
const glutAponBtn = document.querySelectorAll(".gluApo");
glutAponBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutApon.tend = e.target.textContent;
    console.log(e);
  });
}); 
const glutAponRoiBtn = document.querySelectorAll(".gluApoRoi");
glutAponRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    glutApon.roi = e.target.id;
    console.log(e);
  });
}); 

const cluneal = {
  name:'cluneal nerves',
  neuroma: '',
  location: '',
  tender: '',
  roi: '',
  reportLine : function() {
    cluneal.reportLine = clunealReport();
  },
}
function checkCluneal() {
  if (cluneal.tender === "tender") {
    cluneal.roi = 'corresponds'
  }
}
function checkTendinosis() {
  if (keyFinding.target === '' && (glutMed.finding !== 'Normal. ' || glutMin.finding !== 'Normal.')) {
    keyFinding.target = 'trochanteric bursa'
  }
}
const clunNeuBtn = document.querySelectorAll(".cluNeu");
clunNeuBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    cluneal.neuroma = e.target.id;
    console.log(e);
  });
}); 
const clunLocBtn = document.querySelectorAll(".cluRoi");
clunLocBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    cluneal.location = e.target.textContent;
    console.log(e);
  });
});
const clunTenBtn = document.querySelectorAll(".cluTen");
clunTenBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    cluneal.tender = e.target.id;
    console.log(e);
  });
});
function clunealReport() {
  checkCluneal();
if (cluneal.neuroma === '' || cluneal.neuroma === 'Not imaged. ' || cluneal.neuroma === 'No evidence of entrapment. ') {
  cluneal.reportLine = cluneal.neuroma;
} else {
  cluneal.reportLine = 'Localised thickening of a ' + cluneal.location + ' cluneal nerve, suggestive of neuroma.  ' + cluneal.tender + ' to palpation.'
}
}
const reported = {
  latHip: false,
  postHip: false,
  antHip: false,
  inguinal: false,
}
const secReportedBtns = document.querySelectorAll('.secRep');
secReportedBtns.forEach((element) => {
  element.addEventListener("click", function  (e)  {
   let property = this.dataset.prop;
  reported[property] = true;
    console.log(e);
  });
});


function addLatHip() {
    glutMinReport();
    glutMedReport();
    glutBursaRpt();
    glutMuscReport();
    clunealReport();
    if(reported.latHip === true) {
    
    document.getElementById("glutBurRpt").innerHTML = boldString("Trochanteric Bursa  -  ","Trochanteric Bursa") + `${bursa.reportLine}`;
    document.getElementById("glutMedRpt").innerHTML = boldString("Gluteus Medius Tendon  -  ","Gluteus Medius Tendon") + `${glutMed.reportLine}`;
    document.getElementById("glutMinRpt").innerHTML = boldString("Gluteus Minimus Tendon  -  ","Gluteus Minimus Tendon") +`${glutMin.reportLine}`;
    document.getElementById("glutMusRpt").innerHTML = boldString("Gluteal Muscles  -  ","Gluteal Muscles") + `${glutMusc.reportLine}`;
  
    } if (cluneal.reportLine !== '') {
        document.getElementById("clunealRpt").innerHTML = boldString("Cluneal Nerves  -  ","Cluneal Nerves") + `${cluneal.reportLine}`;
    }
    /* else {
      document.getElementById("glutMusRpt").innerHTML = boldString("Lateral Hip  -  ","Lateral Hip") + 'Not imaged.';
    }*/
    }
function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }

function addPostHip() {
    hamstringReport();
    addMagReport();
    
    if (reported.postHip === true) {
      document.getElementById("hamstringRpt").innerHTML = boldString("Hamstring Origin  -  ","Hamstring Origin") + `${hamstring.reportLine}`;
      document.querySelector('#dhrRpt').innerHTML = 
      boldString("Deep hip rotators / Sciatic nerve  -  ","Deep hip rotators / Sciatic nerve") + dhr.finding;
      document.getElementById("addMagRpt").innerHTML = boldString("Adductor Magnus Origin  -  ","Adductor Magnus Origin") + addMag.reportLine;
     
  }}


const dhrBtn = document.querySelectorAll(".dhrNor");
dhrBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    dhr.finding = e.target.id;
    console.log(e);
  });
});
const dhrAbnText = document.querySelector('#dhrAbnText')
dhrAbnText.addEventListener("focusout", (e) => {
  dhr.finding = e.target.value
  console.log(e);
});
const dhr = {
  name: 'deep hip rotator muscles',
  finding: 'Normal. ',
}
const hamstring = {
  name: 'hamstring origin',
  finding : 'Normal. ',
  tear : '',
  retract : '',
  dimension : '',
  tearRoi: '',
  tend: ' normal appearance.',
  tendRoi: '',
  iglBur: '',
  roi: '',
  
  reportLine : function() {
    hamstring.reportLine = hamstringReport();
  },

}
const addMag = {
  name: 'adductor magnus origin',
  ten: 'Normal. ',
  roi: '',
  reportLine : function() {
      addMag.reportLine = addMagReport();
  }
}
function addMagReport() {
    addMag.reportLine = addMag.ten;
    if (addMag.roi === 'corresponds') {
        addMag.reportLine += 'Corresponds to ROI. '
    }
}

const AddBtn = document.querySelectorAll(".addTen");
AddBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  addMag.ten = e.target.id;
    console.log(e);
  });
});
const AddRoiBtn = document.querySelectorAll(".addRoi");
AddRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  addMag.roi = e.target.id;
    console.log(e);
  });
});

function showHamDim() {
    if (hamstring.tear === 'complete tear') {
        hamCompDim.style.display = 'inline'
        hamCompDimReq.style.display = 'inline'
        hamDim.style.display = 'none'
        hamRoiReq.style.display = 'none'
        hamLocDiv.style.display = 'none'
    } if (hamstring.tear === 'partial tear') {
        hamRoiReq.style.display = 'inline'
        hamLocDiv.style.display = 'inline'
        hamDim.style.display = 'inline'
        hamDimReq.style.display = 'inline'
        hamCompDim.style.display = 'none'
    }
}
const hamLocDiv = document.getElementById('hamLocDiv')
const hamDimReq = document.querySelector('#hamDimReq')
const hamCompDimReq = document.querySelector('#hamCompDimReq')
const hamDim = document.getElementById('hamDim')
const hamCompDim =document.getElementById('hamCompDim')
const hamRoiReq = document.querySelector('#hamRoiReq')
const hamTearBtn = document.querySelectorAll(".hamTear");
hamTearBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hamstring.tear = e.target.textContent;
  hamstring.finding = '';
  
  showHamDim();
    console.log(e);
  });
});

const hamTearRoiBtn = document.querySelectorAll(".hamTearRoi");
hamTearRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hamstring.tearRoi = e.target.textContent;
  hamstring.finding = '';
  hamRoiReq.style.display = 'none'
    console.log(e);
  });
});
const hamTendBtn = document.querySelectorAll(".hamTen");
hamTendBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    hamTendReq.style.display = 'inline'
    hamTendDiv.style.display = 'inline'
  hamstring.tend = e.target.textContent;
  hamstring.finding = '';
    console.log(e);
  });
});
const hamTendDiv = document.getElementById('hamTendDiv')
const hamTendReq = document.getElementById('hamTendReq')
const hamRoiBtn = document.querySelectorAll(".hamRoi");
hamRoiBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hamstring.tendRoi = e.target.textContent;
  hamTendReq.style.display = 'none'
  hamstring.finding = '';
    console.log(e);
  });
});
const hamCorBtn = document.querySelectorAll(".hamCor");
hamCorBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hamstring.roi = e.target.textContent;
    console.log(e);
  });
});
const hamDimText = document.querySelector('#hamDimText')
hamDimText.addEventListener("focusout", (e) => {
  hamstring.dimension = e.target.value
  hamstring.finding = '';
  hamDimReq.style.display = 'none'
  console.log(e);
});
const hamCompDimText = document.querySelector('#hamCompDimText')
hamCompDimText.addEventListener("focusout", (e) => {
  hamstring.retract = e.target.value;
  hamstring.finding = '';
  hamCompDimReq.style.display = 'none'
  console.log(e);
});
const hamIglBtn = document.querySelectorAll(".hamIgl");
hamIglBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hamstring.iglBur = e.target.id;
    console.log(e);
  });
});
function hamstringReport() {
 if (hamstring.finding === "Normal. ") {
     hamstring.reportLine = hamstring.finding 
 }
  else if (hamstring.tear === 'complete tear') {
    hamstring.reportLine = hamstring.tear + ', retracted ' +hamstring.retract+ '.'
  } else if (hamstring.tear !== '') {
    hamstring.reportLine = hamstring.dimension + ' ' + hamstring.tear + ' involving the ' + hamstring.tearRoi + ' fibres. Remaining fibres demonstrate ' +hamstring.tend+ '.'
  } else if (hamstring.tend !== ' normal.') {
    hamstring.reportLine = hamstring.tend + ' involving the ' +hamstring.tendRoi + '.  '
  } if (hamstring.iglBur !== '') {
    hamstring.reportLine += ' Ischiogluteal bursa ' + hamstring.iglBur 
  } if (hamstring.roi === 'corresponds') {
    hamstring.reportLine += ' Corresponds to the ROI. '
  }
}
const hipJoint = {
  name : 'Anterior hip joint',
  effusion : 'No joint effusion',
  labrum : 'normal',
  paralab : '',
  dimension : '',
  bone : '',
  roi : '',
  reportLine : function() {
    hipJoint.reportLine = hipJointReport()
  },
}
const hipEffBtn = document.querySelectorAll(".hipEff");
hipEffBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipJoint.effusion = e.target.textContent;
    console.log(e);
  });
});
const hipLabBtn = document.querySelectorAll(".hipLab");
hipLabBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipJoint.labrum = e.target.textContent;
    console.log(e);
  });
});

const hipParaLabBtn = document.querySelectorAll(".hipPar");
hipParaLabBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipJoint.paralab = e.target.textContent;
  getCystDimension()
    console.log(e);
  });
});
const hipCorBtn = document.querySelectorAll(".hipCor");
hipCorBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipJoint.roi = e.target.textContent;
    console.log(e);
  });
});
function getCystDimension() {
  hipJoint.dimension = window.prompt("Enter the dimension of the paralabral cyst (include units).")
  }
const hipBonBtn = document.querySelectorAll(".hipBon");
hipBonBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipJoint.bone = e.target.textContent;
    console.log(e);
  });
});
function hipJointReport() {
  if (hipJoint.dimension !== '' && hipJoint.bone === '') {
    hipJoint.reportLine = hipJoint.effusion + '.  Acetabular labrum appears ' +hipJoint.labrum+ '.  ' +hipJoint.dimension+ '  ' +hipJoint.paralab+ '.'
  } else if (hipJoint.dimension !== "") {
    hipJoint.reportLine = hipJoint.effusion + '.  Acetabular labrum appears ' +hipJoint.labrum+ '.  ' +hipJoint.dimension+ '  ' +hipJoint.paralab+ '.  Bony remodelling suggestive of ' +hipJoint.bone+ '.'
  }
   else if ( hipJoint.bone !== '') {
    hipJoint.reportLine = hipJoint.effusion + '.  Acetabular labrum appears ' +hipJoint.labrum+ '.  Bony remodelling suggestive of ' +hipJoint.bone+ '.'
  } else if (hipJoint.labrum !== 'normal') {
    hipJoint.reportLine = hipJoint.effusion + '.  Acetabular labrum appears ' +hipJoint.labrum+ '. '
  } else {
    hipJoint.reportLine = hipJoint.effusion + '.'
  } 
}

function addAntHip() {
  hipJointReport();
  hipFlexorReport();
  adductorReport();
  if(reported.antHip === true) {
  document.getElementById("hipJoiRpt").innerHTML = boldString("Anterior Hip Joint  -  ","Anterior Hip Joint") + `${hipJoint.reportLine}`;
  document.getElementById("hipFleRpt").innerHTML = boldString("Hip Flexors  -  ","Hip Flexors") + `${hipFlexor.reportLine}`;
  if (adductor.notImaged !== true) {
    document.getElementById("pubTubRpt").innerHTML = boldString("Pubic Tubercle  -  ","Pubic Tubercle") + `${adductor.reportLine}`;  
  }} /*else {
    document.getElementById("hipJoiRpt").innerHTML = boldString("Anterior Hip  -  ","Anterior Hip") + 'Not imaged.';
  }*/
  }



const hipFlexor = {
  name : 'hip flexors',
  location : 'iliopsoas and rectus femoris',
  tend : ' normal. ',
  bursa : '',
  bursDim : '',
  lfcn : '',
  reportLine : function () {
    hipFlexor.reportLine = hipFlexorReport();
  }
}
const hipFleLocBtn = document.querySelectorAll(".fleLoc");
hipFleLocBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipFlexor.location = e.target.textContent;
    console.log(e);
  });
});
const hipFleTenBtn = document.querySelectorAll(".fleTen");
hipFleTenBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipFlexor.tend = e.target.textContent;
    console.log(e);
  });
});
const hipFleBurBtn = document.querySelectorAll(".fleBur");
hipFleBurBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipFlexor.bursa = e.target.textContent;
  getFleBurDim();
    console.log(e);
  });
});
const lfcnBtn = document.querySelectorAll(".lfcn");
lfcnBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  hipFlexor.lfcn = e.target.id;
    console.log(e);
  });
});
function getFleBurDim() {
  hipFlexor.bursDim = window.prompt("Enter the dimension of the iliopsoas bursa (include units).")
  }
function hipFlexorReport() {
  if (hipFlexor.bursDim !== '') {
    hipFlexor.reportLine =   hipFlexor.location +' ' +hipFlexor.tend + '.  '  +hipFlexor.bursa+ ' of the iliopsoas bursa with maximal dimension of ' +hipFlexor.bursDim+ '.  '
  } if (hipFlexor.bursDim === '') {
    hipFlexor.reportLine = hipFlexor.location +' ' + hipFlexor.tend + '.  No iliopsoas bursitis. '
  } if (hipFlexor.lfcn !== '') {
    hipFlexor.reportLine += hipFlexor.lfcn
  }
  
}
const adductor = {
  name : 'Adductor origin',
  tend : 'has normal appearance,',
  notImaged : '',
  cor : '',
  muscle : '',
  tubercle :'Conjoint tendon and inguinal ligament appear normal.',
  symph : 'Symphysis pubis normal.',
  rectus : 'Rectus abdominus muscle normal.',
  reportLine : '',
}

const addNotImagedBtn = document.querySelector('#addNI')
addNotImagedBtn.addEventListener("click", (e) => {
  adductor.notImaged = true;
  console.log(e);
});


const aoTenBtn = document.querySelectorAll(".addOri");
aoTenBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  notImaged.adductor = false;
  adductor.reportLine = ''
  adductor.tend = e.target.id;
    console.log(e);
  });
});
const addCorBtn = document.querySelectorAll(".addCor");
addCorBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  adductor.cor = e.target.id;
    console.log(e);
  });
});
const addMusText = document.querySelector("#addMusText");
addMusText.addEventListener("focusout", (e) => {
  adductor.muscle = e.target.value;
    console.log(e);
  });

const pubTubText = document.querySelector("#pubTubText");
pubTubText.addEventListener("focusout", (e) => {
  adductor.tubercle = e.target.value;
    console.log(e);
  });

const symphBtn = document.querySelectorAll(".symph");
symphBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  adductor.symph = e.target.id;
    console.log(e);
  });
});
const recMusText = document.querySelector("#recMusText");
recMusText.addEventListener("focusout", (e) => {
  adductor.rectus = e.target.value;
    console.log(e);
  });

function adductorReport() {
  if (adductor.notImaged === true) {
    adductor.reportLine = 'Not Imaged. ';
  }
 else if (adductor.reportLine === '') {
  adductor.reportLine = Object.values(adductor).join(' ');
 } else if (adductor.cor !== '') {
  adductor.reportLine = 'Adductor origin ' +adductor.tend+ ' which '+adductor.cor+ ' to the ROI. ' +adductor.muscle+ '  '+adductor.tubercle+'  '+adductor.symph+' '+adductor.rectus
 }

 else {
   adductor.reportLine = '';
   adductor.reportLine = Object.values(adductor).join(' ');
 }
 }
const rightInguinal = {
  name : 'Right inguinal region',
  direct : 'No inguinal hernia. ',
  content : '',
  canDiam : '',
  defDiam : '',
  reduce : '',
  femoral : 'No femoral hernia. ',
  femContent : '',
  femDim : '',
  femComp :'',
  lipoma : '',
  lipDim: '',
  spigelian : '',
  spigDim : '',
  roi : '',
  reportLine : ''
}
const rgCorBtn = document.querySelectorAll(".rgCor");
rgCorBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.roi = e.target.textContent;
    console.log(e);
  });
});
const rIngDirBtn = document.querySelectorAll(".rIngDir");
rIngDirBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.direct = e.target.id;
  getRightHerDim();
    console.log(e);
  });
});
const lIngDirBtn = document.querySelectorAll(".lIngDir");
lIngDirBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.direct = e.target.id;
  getLeftHerDim();
    console.log(e);
  });
});
const lIngConBtn = document.querySelectorAll(".lIngCon");
lIngConBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.content = e.target.id;
    console.log(e);
  });
});
const rIngConBtn = document.querySelectorAll(".rIngCon");
rIngConBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.content = e.target.id;
    console.log(e);
  });
});
const rIngRedBtn = document.querySelectorAll(".rIngRed");
rIngRedBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.reduce = e.target.id;
    console.log(e);
  });
});
const lIngRedBtn = document.querySelectorAll(".lIngRed");
lIngRedBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.reduce = e.target.id;
    console.log(e);
  });
});
const lIngFemBtn = document.querySelectorAll(".lIngFem");
lIngFemBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.femoral = e.target.id;
  getLeftHerDim();
    console.log(e);
  });
});
const rIngFemBtn = document.querySelectorAll(".rIngFem");
rIngFemBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.femoral = e.target.id;
  getRightHerDim();
    console.log(e);
  });
});
const rIngFemConBtn = document.querySelectorAll(".rIngFemCon");
rIngFemConBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.femContent = e.target.id;
    console.log(e);
  });
});
const rIngFemCompBtn = document.querySelectorAll(".rIngFemComp");
rIngFemCompBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.femComp = e.target.id;
    console.log(e);
  });
});
const lIngFemCompBtn = document.querySelectorAll(".lIngFemComp");
lIngFemCompBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.femComp = e.target.id;
    console.log(e);
  });
});
const lIngFemConBtn = document.querySelectorAll(".lIngFemCon");
lIngFemConBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.femContent = e.target.id;
    console.log(e);
  });
});
const lIngLipBtn = document.querySelectorAll(".lIngLip");
lIngLipBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.lipoma = e.target.id;
  getLeftHerDim();
    console.log(e);
  });
});
const rIngLipBtn = document.querySelectorAll(".rIngLip");
rIngLipBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.lipoma = e.target.id;
  getRightHerDim();
    console.log(e);
  });
});
const rIngSpigBtn = document.querySelectorAll(".rIngSpig");
rIngSpigBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  rightInguinal.spigelian = e.target.id;
  getRightHerDim();
    console.log(e);
  });
});
const lIngSpigBtn = document.querySelectorAll(".lIngSpig");
lIngSpigBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.spigelian = e.target.id;
  getLeftHerDim();
    console.log(e);
  });
});
const lgCorBtn = document.querySelectorAll(".lgCor");
lgCorBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
  leftInguinal.roi = e.target.textContent;
    console.log(e);
  });
});
function getRightHerDim() {
  if (rightInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ' && rightInguinal.defDiam === '') {
    rightInguinal.defDiam = window.prompt("Enter the DEFECT SIZE (include units)")
  } if (rightInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ' && rightInguinal.canDiam === '') {
    rightInguinal.canDiam = window.prompt("Enter the inguinal CANAL DIAMETER (include units)")
  } if (rightInguinal.direct === 'Direct inguinal hernia. ' && rightInguinal.defDiam === '') {
    rightInguinal.defDiam = window.prompt("Enter the DEFECT SIZE (include units)")
  } if (rightInguinal.direct === 'Indirect inguinal hernia. ' && rightInguinal.canDiam === '') {
    rightInguinal.canDiam = window.prompt("Enter the inguinal CANAL DIAMETER (include units)")
  } if (rightInguinal.lipoma !== '' && rightInguinal.lipDim === '') {
    rightInguinal.lipDim = window.prompt("Enter the inguinal LIPOMA dimesnions (include units)")
  } if (rightInguinal.spigelian !== '' && rightInguinal.spigDim === '') {
    rightInguinal.spigDim = window.prompt("Enter the SPIGELIAN HERNIA dimensions (include units)")
  } if (rightInguinal.femoral !== 'No femoral hernia. ' && rightInguinal.femDim === '') {
    rightInguinal.femDim = window.prompt("Enter the FEMORAL HERNIA diameter (include units)")
  } 
    else {
    return
  }
}
function getLeftHerDim() {
  if (leftInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ' && leftInguinal.defDiam === '') {
    leftInguinal.defDiam = window.prompt("Enter the DEFECT SIZE (include units)")
  } if (leftInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ' && leftInguinal.canDiam === '') {
    leftInguinal.canDiam = window.prompt("Enter the inguinal CANAL DIAMETER (include units)")
  } if (leftInguinal.direct === 'Direct inguinal hernia. ' && leftInguinal.defDiam === '') {
    leftInguinal.defDiam = window.prompt("Enter the DEFECT SIZE (include units)")
  } if (leftInguinal.direct === 'Indirect inguinal hernia. ' && leftInguinal.canDiam === '') {
    leftInguinal.canDiam = window.prompt("Enter the inguinal CANAL DIAMETER (include units)")
  } if (leftInguinal.lipoma !== '' && leftInguinal.lipDim === '') {
    leftInguinal.lipDim = window.prompt("Enter the inguinal LIPOMA dimesnions (include units)")
  } if (leftInguinal.spigelian !== '' && leftInguinal.spigDim === '') {
    leftInguinal.spigDim = window.prompt("Enter the SPIGELIAN HERNIA dimensions (include units)")
  } if (leftInguinal.femoral !== 'No femoral hernia. ' && leftInguinal.femDim === '') {
    leftInguinal.femDim = window.prompt("Enter the FEMORAL HERNIA diameter (include units)")
  } 
    else {
    return
  }
}
const leftInguinal = {
  name: 'Left inguinal region',
  direct : 'No inguinal hernia. ',
  content : '',
  canDiam : '',
  defDiam : '',
  reduce : '',
  femoral : 'No femoral hernia. ',
  femContent : '',
  femDim : '',
  femComp : '',
  lipoma : '',
  lipDim: '',
  spigelian : '',
  spigDim : '',
  roi :'',
  reportLine : ''
}
function leftInguinalReport() {
  
  leftInguinal.reportLine = leftInguinal.direct + leftInguinal.femoral

if (leftInguinal.direct === 'Direct inguinal hernia. ' && leftInguinal.direct !== 'Laxity of the transversalis fascia suggestive of fascial strain, with no direct inguinal hernia identified. ' ) {
  leftInguinal.reportLine = leftInguinal.direct +leftInguinal.content+ ' Maximal defect dimension '+ leftInguinal.defDiam+ '. '+leftInguinal.reduce +leftInguinal.femoral
}
if (leftInguinal.direct === 'Indirect inguinal hernia. ' && leftInguinal.direct !== 'Laxity of the transversalis fascia suggestive of fascial strain, with no direct inguinal hernia identified. ' ) {
  leftInguinal.reportLine = leftInguinal.direct +leftInguinal.content+ ' Inguinal canal diameter '+leftInguinal.canDiam+ '. '+leftInguinal.reduce +leftInguinal.femoral
}
if (leftInguinal.femoral !== 'No femoral hernia. ' ) {
  leftInguinal.reportLine += leftInguinal.femDim+ '. ' +leftInguinal.femContent + leftInguinal.femComp
}
if (leftInguinal.spigelian !== '') {
  leftInguinal.reportLine += leftInguinal.spigelian + leftInguinal.spigDim + '. '
} if (leftInguinal.lipoma !== '') {
  leftInguinal.reportLine += leftInguinal.lipoma + leftInguinal.lipDim + '. '
}
if (leftInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ') {
  leftInguinal.reportLine = leftInguinal.direct + leftInguinal.content + ' Canal diameter measures '+leftInguinal.canDiam+ '. The posterior canal defect measures '+leftInguinal.defDiam+ '. ' +leftInguinal.reduce+ '. ' +leftInguinal.femoral + 
  +leftInguinal.femContent + leftInguinal.femComp
}
}
function rightInguinalReport() {
  
    rightInguinal.reportLine = rightInguinal.direct + rightInguinal.femoral
  
  if (rightInguinal.direct === 'Direct inguinal hernia. ' && rightInguinal.direct !== 'Laxity of the transversalis fascia suggestive of fascial strain, with no direct inguinal hernia identified. ' ) {
    rightInguinal.reportLine = rightInguinal.direct +rightInguinal.content+ ' Maximal defect dimension '+ rightInguinal.defDiam+ '. '+rightInguinal.reduce +rightInguinal.femoral
  }
  if (rightInguinal.direct === 'Indirect inguinal hernia. ' && rightInguinal.direct !== 'Laxity of the transversalis fascia suggestive of fascial strain, with no direct inguinal hernia identified. ' ) {
    rightInguinal.reportLine = rightInguinal.direct +rightInguinal.content+ ' Inguinal canal diameter '+rightInguinal.canDiam+ '. '+rightInguinal.reduce +rightInguinal.femoral
  }
  if (rightInguinal.femoral !== 'No femoral hernia. ' ) {
    rightInguinal.reportLine += rightInguinal.femDim+ '. ' +rightInguinal.femContent + rightInguinal.femComp
  }
  if (rightInguinal.spigelian !== '') {
    rightInguinal.reportLine += rightInguinal.spigelian + rightInguinal.spigDim + '. '
  } if (rightInguinal.lipoma !== '') {
    rightInguinal.reportLine += rightInguinal.lipoma + rightInguinal.lipDim + '. '
  }
  if (rightInguinal.direct === 'Concomitant indirect and direct inguinal herniae. ') {
    rightInguinal.reportLine = rightInguinal.direct + rightInguinal.content + ' Canal diameter measures '+rightInguinal.canDiam+ '. The posterior canal defect measures '+rightInguinal.defDiam+ '. ' +rightInguinal.reduce+ '. ' +rightInguinal.femoral + 
    +rightInguinal.femContent + rightInguinal.femComp
  }
}

function addInguinal() {
  rightInguinalReport(); 
  leftInguinalReport();
  if(reported.inguinal === true) {
  document.getElementById("rightIngRpt").innerHTML = boldString("Right Groin  -  ","Right Groin") + `${rightInguinal.reportLine}`;
  document.getElementById("leftIngRpt").innerHTML = boldString("Left Groin  -  ","Left Groin") + `${leftInguinal.reportLine}`;
  
  } /* else { 
    document.getElementById("rightIngRpt").innerHTML = boldString("Inguinal Canals  -  ","Inguinal Canals") + 'Not imaged.';
  }*/
  }
/*
 const keyFinding = {
  target : '',
  secTarget: '',
  reportLine: function() {
   keyFinding.reportLine = keyReport();
  },
  }
const objects = [glutMed, glutMin, bursa, glutApon, cluneal, dhr, hamstring, addMag, hipJoint, adductor, rightInguinal, leftInguinal]

function defineTarget() {
  objects.forEach(function (element) {
    if (keyFinding.target !== '' ) {
      defineSecTarget();
    }
  else if (element.roi === 'corresponds') {
    keyFinding.target = element.name
  } else {
    
}})};

function defineSecTarget() {
  objects.forEach(function (element) {
    if (element.roi === 'corresponds' && keyFinding.target !== element.name) {
    keyFinding.secTarget = element.name
}
})};

function addKeyFinding() {
  keyReport();
  document.getElementById("sumRpt").innerHTML = boldString("Key Finding  -  ","Key Finding") + `${keyFinding.reportLine}`;
  showReportModal();
}
function clearKeyFindings () {
  keyFinding.target = '';
  keyFinding.secTarget = '';
}
function keyReport() {
  clearKeyFindings();
  defineTarget();
  if (hipFlexor.tend === 'apophyseal avulsion') {
    keyFinding.reportLine = "The ROI corresponds to the rectus femoris origin. Findings as described above. "
  }
  else if (keyFinding.target === 'Right inguinal region' || keyFinding.target === 'Left inguinal region' ) {
    keyFinding.reportLine = "The ROI corresponds to the " + keyFinding.target +". Findings as described above. "
  }
  else if (keyFinding.secTarget === 'Right inguinal region' || keyFinding.secTarget === 'Left inguinal region' ) {
    keyFinding.reportLine = "There is abnormality at the " +keyFinding.secTarget+ " which corresponds to the ROI. The patient also indicates symptoms at the " +keyFinding.target+ " which may be amenable to HCLA injection."
  }else if (keyFinding.target === '') {
    keyFinding.reportLine = 'No cause for presentation has been defined. Futher investigation may be indicated.'
  }
  else if (keyFinding.target !== 'trochanteric bursa' && bursa.thick !== 'Normal thickness. ' && history.roi !== 'anterior hip' && history.roi !== 'groin') {
    keyFinding.reportLine = 'ROI corresponds to the ' + keyFinding.target + ' HCLA injection to this location could be considered. If this injection is only partially effective, HCLA injection of the trochanteric bursa may also be indicated.'
  } else if (keyFinding.target !== '' && keyFinding.secTarget !== '') {
    keyFinding.reportLine = 'Clinical and imaging findings indicate contributing abnormalities at both the ' + keyFinding.target + ' and the ' +keyFinding.secTarget + '. HCLA injection at one or both of these locations could be considered.'
  }
  else {
    keyFinding.reportLine = 'ROI corresponds to the ' + keyFinding.target + '. HCLA injection to this location could be considered.'
  }
  }

const sumRepBtn = document.querySelector("#sumRep");
sumRepBtn.addEventListener("click", () => {
    reported.key = true
    addKeyFinding();
});
*/
function reportAllModules() {
    reported.latHip  = true
    reported.postHip = true
    reported.antHip = true
    reported.inguinal = true
    reported.key = true
}
function populate() {
    checkID();
    if (identifier.patient === '' || identifier.sono === '' ) {
      return
     }
    addClin();
     if (history.side === "" ) {
      return
    }
    addLatHip();
    addPostHip();
    addAntHip();
    addInguinal();
    showReportModal();
    }

    const openWSBtn = document.querySelector("#panRep");
    openWSBtn.addEventListener("click", () => {
        identifier.reported = true;
      populate();
    });
    
    const reOpenWSBtn = document.querySelector("#savRep");
    reOpenWSBtn.addEventListener("click", () => {
      showReportModal();
    });

    const panels = Array.from(document.getElementsByClassName('w3-panel'));
    panels.forEach((element) =>  {
      element.addEventListener('click',(e) => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
      });
        console.log(e);
      })
    });
  
    
  
    function hideElements(array) {
      array.forEach(function (element) {
        element.style.display = 'none';
      })
    }   function displayElements(array) {
     array.forEach(function (element) {
       element.style.display = 'inline';
     })
   }  
    function hideDiv(id) {
    document.getElementById(id).style.display = 'none';
    }
    function displayDiv(id) {
      document.getElementById(id).style.display = 'inline'
    }